import React from 'react';
import './SubscriptionBadge.css';

/**
 * SubscriptionBadge Component
 *
 * Displays user's subscription tier as a badge
 * Shows different styles for free, paid, and enterprise tiers
 *
 * @param {string} tier - Subscription tier ('free', 'paid', 'enterprise')
 * @param {string} workspaceRole - Optional role in workspace ('owner', 'invited')
 * @param {string} size - Badge size ('small', 'medium', 'large')
 */
const SubscriptionBadge = ({ tier, workspaceRole, size = 'medium' }) => {
  // Determine badge content and style based on tier and role
  const getBadgeConfig = () => {
    // If user is invited to a workspace, show that instead
    if (workspaceRole === 'invited') {
      return {
        text: 'Invited Workspace',
        className: 'badge-invited',
        icon: '👥'
      };
    }

    // Otherwise show subscription tier
    switch (tier) {
      case 'paid':
      case 'enterprise':
        return {
          text: 'Premium',
          className: 'badge-paid',
          icon: '✓'
        };
      case 'free':
      default:
        return {
          text: 'Free Plan',
          className: 'badge-free',
          icon: ''
        };
    }
  };

  const config = getBadgeConfig();

  return (
    <span className={`subscription-badge ${config.className} badge-${size}`}>
      {config.icon && <span className="badge-icon">{config.icon}</span>}
      <span className="badge-text">{config.text}</span>
    </span>
  );
};

export default SubscriptionBadge;
